import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-footer-menu-links',
  templateUrl: './bmcore-footer-menu-links.component.html',
  styleUrls: ['./bmcore-footer-menu-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFooterMenuLinksComponent implements OnInit {
  @Input() links: Array<string> = []

  lg: LgType

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }
}
